module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/hamburger-54d07ab3fa4c5625c5386c1404d28938.svg";